import {COLOUR, DARK_COLOUR, LIGHT_COLOUR} from './COLOUR'
import {EFFECTS} from './EFFECTS'
import {LAYOUT} from './LAYOUT'
import {SIZE} from './SIZE'
import {TYPOGRAPHY} from './TYPOGRAPHY'

export const lightTheme = {
  COLOUR: LIGHT_COLOUR,
  SIZE,
  TYPOGRAPHY,
  EFFECTS,
  LAYOUT,
}

export const defaultTheme = {
  COLOUR,
  SIZE,
  TYPOGRAPHY,
  EFFECTS,
  LAYOUT,
}

export const darkTheme = {
  COLOUR: DARK_COLOUR,
  SIZE,
  TYPOGRAPHY,
  EFFECTS,
  LAYOUT,
}

export type Theme = typeof defaultTheme

interface Props {
  theme: Theme
}

export const theme = (props: Props) => props.theme
